@if (vm$ | async; as vm) {
  <div class="metadata-panel" data-qa="metadataPanel">
    <!-- Status Banner -->
    <jui-alert-block
      class="metadata-panel__status"
      size="sm"
      [color]="vm.statusColor"
      [iconName]="vm.statusIcon"
      [titleText]="vm.statusTitle"
      data-qa="metadataPanel_status"
    >
      {{ vm.statusMessage }}
    </jui-alert-block>

    <div class="metadata-panel__inner">
      <!-- Quality Section -->
      <div class="metadata-panel__section" data-qa="metadataPanel_quality">
        <div class="metadata-panel__section-header">
          <span>{{ vm.labels.quality }}</span>
          <span
            class="metadata-panel__status-text"
            [ngClass]="vm.qualityAcceptableColorClass"
            data-qa="metadataPanel_qualityStatus"
          >
            {{ vm.qualityAcceptableDisplay }}
          </span>
        </div>
        <div class="metadata-panel__row">
          <span class="metadata-panel__label">{{ vm.labels.overallScore }}</span>
          <div class="metadata-panel__score">
            <span class="metadata-panel__value" data-qa="metadataPanel_qualityScore">{{ vm.qualityScoreDisplay }}</span>
            <div class="metadata-panel__progress">
              <div
                class="metadata-panel__progress-bar"
                [ngClass]="vm.qualityScoreColorClass"
                [style.width.%]="vm.qualityScore"
              ></div>
            </div>
          </div>
        </div>

        @for (detail of vm.qualityDetails; track detail.label) {
          <div class="metadata-panel__row metadata-panel__row--sub">
            <span class="metadata-panel__label metadata-panel__label--sub">{{ detail.label }}</span>
            <div class="metadata-panel__score">
              <span class="metadata-panel__value metadata-panel__value--sub">{{ detail.valueDisplay }}</span>
              <div class="metadata-panel__progress metadata-panel__progress--small">
                <div
                  class="metadata-panel__progress-bar"
                  [ngClass]="detail.colorClass"
                  [style.width.%]="detail.value"
                ></div>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Detection Section -->
      @if (vm.showDetection) {
        <div class="metadata-panel__section" data-qa="metadataPanel_detection">
          <div class="metadata-panel__section-header">
            <span>{{ vm.labels.detection }}</span>
            <span
              class="metadata-panel__status-text"
              [ngClass]="vm.confidenceThresholdMetColorClass"
              data-qa="metadataPanel_detectionStatus"
            >
              {{ vm.confidenceThresholdMetDisplay }}
            </span>
          </div>
          <div class="metadata-panel__row">
            <span class="metadata-panel__label">{{ vm.labels.equipmentType }}</span>
            <span class="metadata-panel__value" data-qa="metadataPanel_equipmentType">{{ vm.equipmentType }}</span>
          </div>
          <div class="metadata-panel__row">
            <span class="metadata-panel__label">{{ vm.labels.confidence }}</span>
            <div class="metadata-panel__score">
              <span class="metadata-panel__value" data-qa="metadataPanel_confidence">{{ vm.confidenceDisplay }}</span>
              <div class="metadata-panel__progress">
                <div
                  class="metadata-panel__progress-bar"
                  [ngClass]="vm.confidenceColorClass"
                  [style.width.%]="vm.confidence"
                ></div>
              </div>
            </div>
          </div>

          @if (vm.boundingBoxCount > 0) {
            <div class="metadata-panel__row">
              <span class="metadata-panel__label">{{ vm.labels.boundingBoxes }}</span>
              <div class="metadata-panel__bbox-toggle">
                <jui-button
                  size="xs"
                  display="ghost"
                  (click)="onToggleBoundingBoxes()"
                  [attr.aria-label]="showBoundingBoxes ? vm.labels.hideBoundingBoxes : vm.labels.showBoundingBoxes"
                  data-qa="metadataPanel_bboxToggle"
                >
                  {{ showBoundingBoxes ? vm.labels.hide : vm.labels.show }}
                </jui-button>
              </div>
            </div>
          }
        </div>
      }

      <!-- Dimensions Section -->
      @if (vm.showDimensions) {
        <div class="metadata-panel__section" data-qa="metadataPanel_dimensions">
          <div class="metadata-panel__section-header">{{ vm.labels.dimensions }}</div>
          @if (vm.imageWidth && vm.imageHeight) {
            <div class="metadata-panel__row">
              <span class="metadata-panel__label">{{ vm.labels.imageSize }}</span>
              <span class="metadata-panel__value">{{ vm.imageWidth }} x {{ vm.imageHeight }}</span>
            </div>
          }
          @if (vm.sourceWidth && vm.sourceHeight) {
            <div class="metadata-panel__row">
              <span class="metadata-panel__label">{{ vm.labels.sourceSize }}</span>
              <span class="metadata-panel__value">{{ vm.sourceWidth }} x {{ vm.sourceHeight }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
